module.exports = "<div *ngIf=\"api\" class=\"center\">\n  <sidebar [api]=\"api\" [devMode]=\"devMode\" class=\"soft-bg-color\"></sidebar>\n  <div class=\"content soft-bg-color\">\n    <query-section [devMode]=\"devMode\"></query-section>\n    <response-section></response-section>\n  </div>\n  <explorer *ngIf=\"devMode\" [api]=\"api\" class=\"soft-bg-color\"></explorer>\n</div>\n<div *ngIf=\"!api\" class=\"loading-container\">\n  <div class=\"loading-pulse\"></div>\n  <h3>{{nullAPIMessage}}</h3>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/project-detail/project-detail.html
 ** module id = 802
 ** module chunks = 0
 **/